import { useState, useEffect } from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import { useQuery } from "@tanstack/react-query";

const useProcessToday = () => {
  const axiosPrivate = useAxiosPrivate();
  const [processToday, setProcessToday] = useState({
    counter_success: 0,
    counter_pending_review: 0,
  });

  const { data } = useQuery({
    queryKey: ["processedToday"],
    queryFn: async () => {
      const response = await axiosPrivate.get(`/orders/processedToday`);
      return response.data;
    },
    staleTime: 60000,
    gcTime: 60000,
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
    refetchIntervalInBackground: true,
  });

  useEffect(() => {
    if (data) {
      setProcessToday(data);
    }
  }, [data]);

  return processToday;
};

export default useProcessToday;
